/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { RuntimeNodeInstrumentation } from './instrumentation';
export type { RuntimeNodeInstrumentationConfig } from './types';
